export const isCurrentType = (type, currentType) => (type === currentType);



// WEBPACK FOOTER //
// ./src/containers/Page/ElementSelector/helpers/isCurrentType.js